import ToolStylus from './ToolStylus';

class ToolStylusTable extends ToolStylus {
  static toolName = 'Table';

  static action({ controller }) {
    controller.actionSetStylus(controller.StylusTable);
  }
}

export default ToolStylusTable;
